import { cellLineaRazonSocial, gridSizeMdLg10, ROUTER_PATHS, useCustomStepper } from "@/shared";
import { StepperBoxScene } from "@/shared/components/ui"
import { IDataPreventa, TipoSolicitudesEnum } from "@/shared/interfaces";
import { useNavigate } from "react-router-dom";
import TabInformacionPersonalPreventaPymes from "../tabs_formulario_preventa_pymes/TabInformacionPersonalPreventaPymes";
import TabResidenciaPreventaPymes from "../tabs_formulario_preventa_pymes/TabResidenciaPreventaPymes";
import TabServicioPreventaPymes from "../tabs_formulario_preventa_pymes/TabServicioPreventaPymes";
import TabOtrosCargosPreventaPymes from "@/erp/sale/asesor/preventa/shared/component/Tabs/TabOtrosCargosPreventaPymes";
import TabDocumentosPreventaPymes from "../tabs_formulario_preventa_pymes/TabDocumentosPreventa";
import { useFormPreventaPymes } from "../../hook/useFormPreventaPymes";
import LoadPreventa from "@/erp/sale/asesor/preventa/shared/component/load_preventa/LoadPreventa";
import { IProspectoPymes } from "@/shared/interfaces/erp/ventas_pymes/prospecto_pymes.interface";
import TipoVentaCanjeEvento from "@/shared/components/ui/TipoVentaCanjeEvento/TipoVentaCanjeEvento";

const steps = [
  "Informacion",
  "Punto de Enlace",
  "Servicio",
  "Otros Cargos",
  "Documentos",
];

interface SavePreventaPymesProps {
  dataProspecto: IProspectoPymes;
  dataPreventa?: IDataPreventa;
  editSupervisor?: boolean;
}

export default function SavePreventaPymes({
  editSupervisor = false,
  dataProspecto,
  dataPreventa
}: SavePreventaPymesProps) {

  const navigate = useNavigate()

  const {
    activeStep,
    handleBack,
    handleNext, disableNextStepBtn
  } = useCustomStepper({ steps: steps })

  const formPreventa = useFormPreventaPymes({
    prospectoResp: dataProspecto,
    editSupervisor,
    dataPreventa
  })

  return <>
    <StepperBoxScene
      titlePage={`${editSupervisor ? "Editar" : "Crear"} Preventa`}
      num_referencia={cellLineaRazonSocial(null, dataPreventa?.prospecto_data?.razon_social!, dataPreventa?.contrato_data?.linea)}
      steps={steps}
      activeStep={activeStep}
      handleNext={handleNext}
      handleBack={handleBack}
      disableNextStepBtn={disableNextStepBtn}
      onCancel={() => {
        navigate(ROUTER_PATHS.ventasPymes.prospectoNav)
        formPreventa.form.reset({})
      }}
      onSave={formPreventa.form.handleSubmit((form) => {
        formPreventa.handleOnSubmit(form)
      }, (error) => {
        console.log(error);

        formPreventa.handleError(error)
      })}
      size={gridSizeMdLg10}
      py={0}
      additionalNoteText={
        <TipoVentaCanjeEvento
          prospecto_data={dataProspecto as any}
          tipo_venta={TipoSolicitudesEnum.PYMES}
        />
      }
    >

      {activeStep === 0 && (
        <TabInformacionPersonalPreventaPymes
          editSupervisor={editSupervisor}
          {...formPreventa}
        />
      )}

      {activeStep === 1 && (
        <TabResidenciaPreventaPymes
          editSupervisor={editSupervisor}
          {...formPreventa}
        />
      )}
      {activeStep === 2 && (
        <TabServicioPreventaPymes
          editSupervisor={editSupervisor}
          {...formPreventa}
        />
      )}
      {activeStep === 3 && (
        <TabOtrosCargosPreventaPymes
          editSupervisor={editSupervisor}
          {...formPreventa}
        />
      )}

      {activeStep === 4 && (
        <TabDocumentosPreventaPymes
          editSupervisor={editSupervisor}
          {...formPreventa}
        />
      )}

    </StepperBoxScene>

    <LoadPreventa
      open={formPreventa.isPendingUpdatePreventa || formPreventa.isPendingPreventa}
    />


  </>

}